<template>
  <div class="gmf-date-input" @click="open = true">
    <div v-text="formattedValue || placeholder"></div>
  </div>
  <Modal v-model="open" :stackModals="true">
      <div class="gmf-date-input-modal">
        <div class="gmf-subheader gmf-mb-0">{{ t('input.date_modal.header') }}</div>
        <div class="gmf-text-input">
          <input type="date" max="3000-01-01" min="1000-01-01" v-model="inputValue" :style="computedStyle" ref="inputEl" />
        </div>
        <div class="gmf-alert gmf-alert-error" v-if="showValidationError">
          {{ t('errors.invalid_date') }}
        </div>
        <div class="gmf-date-input-modal-footer">
          <button class="gmf-btn gmf-btn-secondary gmf-btn-sm" @click="unset" v-text="t('generic.delete')" />
          <button class="gmf-btn gmf-btn-primary gmf-btn-sm" :disabled="! inputValueIsValid || inputValue == modelValue" @click="save" v-text="t('input.date_modal.confirm')" />
        </div>
      </div>
    </Modal>
</template>

<style>
.gmf-date-input {
  width: 100%;
}
.gmf-date-input {
  background: var(--gmf-input-bg);
  border: none;
  padding: 12px 16px;
  border-radius: var(--gmf-rounding);
  width: 100%;
  font-size: var(--gmf-default-font-size);
  cursor: pointer;
}
.gmf-date-input:hover {
  background: var(--gmf-col-gray);
}
/*.gmf-date-input input::placeholder {
  color: var(--gmf-col-darkgray);
}*/


.gmf-date-input-modal {
  width: 300px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--gmf-p-4);
}
.gmf-date-input-modal-footer {
  display: flex;
  gap: var(--gmf-p-3);
}
</style>

<script>
import state from '@/state';
import getBrowserInfo from '@/utils/tracking';
import Modal from '@/components/Modal';

const info = getBrowserInfo();

const isIOS = info.device.os === 'iOS';

export default {
  props: ['modelValue', 'placeholder'],

  components: {
    Modal,
  },

  data () {
    return {
      open: false,
      inputValue: this.modelValue,
      showValidationError: false,
    };
  },

  computed: {
    inputValueIsValid () {
       if (! (this.inputValue && this.inputValue.length > 0)) {
          return false;
       }
       // Date must be in format YYYY-MM-DD

        const parts = this.inputValue.split('-');
        if (parts.length !== 3) {
          return false;
        }

        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]);
        const day = parseInt(parts[2]);

        if (isNaN(year) || isNaN(month)) {
          return false;
        }

        if (year < 1900 || year > 2100) {
          return false;
        }

        if (month < 1 || month > 12) {
          return false;
        }

        if (day < 1 || day > 31) {
          return false;
        }

        return true;
    },
    formattedValue () {
      if (! this.modelValue) {
        return null;
      }
      return this.modelValue;
    },
    computedStyle() {
      if (isIOS) {
        return {
          fontSize: '16px',
        }
      }

      return null;
    }
  },

  methods: {
    t: state.t,
    /*cancel () {
      this.inputValue = this.modelValue;
      this.open = false;
    },*/
    unset () {
      this.inputValue = null;
      this.$emit('update:modelValue', this.inputValue);
      this.open = false;
    },
    save () {
      if (! this.inputValueIsValid) {
        this.showValidationError = true;
        return;
      }
      this.$emit('update:modelValue', this.inputValue);
      this.open = false;
    },
  },

  watch: {
    open (v) {
      if (v) {
        this.showValidationError = false;
        this.$nextTick(() => {
          this.$refs.inputEl.focus();
        });
      }
    },
    modelValue (val) {
      this.inputValue = val;
    },
  },
};
</script>
